
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 64c8.547 0 16.583-3.329 22.627-9.374 6.045-6.044 9.374-14.079 9.374-22.626s-3.329-16.582-9.374-22.626C48.583 3.329 40.547 0 32 0 23.452 0 15.417 3.329 9.373 9.374 3.328 15.418-.001 23.453-.001 32s3.329 16.582 9.374 22.626C15.417 60.671 23.452 64 32 64zM10.787 10.788C16.453 5.121 23.986 2 32 2c8.013 0 15.547 3.121 21.213 8.788C58.88 16.454 62.001 23.987 62.001 32s-3.121 15.546-8.788 21.212C47.547 58.879 40.013 62 32 62c-8.014 0-15.547-3.121-21.213-8.788C5.12 47.546 1.999 40.013 1.999 32s3.121-15.546 8.788-21.212z"}}),_c('path',{attrs:{"d":"M31 17h2v22h-2zm0 26h2v4h-2z"}})])
          )
        }
      }
    